function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var isWindowDataLayer = function isWindowDataLayer(dataLayer) {
  if (!window.dataLayer) {
    return false;
  }
  return true;
};

/* TODO: Replace this with function imported from client-utils
This is a copy of the function in client-utils. Adding client-utils as a dependency of this
package resulted in typescript compilation errors when running the site-chrome TestCafe tests.
 */
export var linkClickOpensInNewTab = function linkClickOpensInNewTab(evt, eventTarget) {
  var target = (eventTarget || evt.currentTarget).getAttribute('target') || '_self';
  var modifier = [evt.shiftKey, evt.ctrlKey, evt.metaKey].some(function (k) {
    return k === true;
  });
  return target !== '_self' || modifier;
};
export var hasMatchingDataLayerEvent = function hasMatchingDataLayerEvent(event) {
  if (!isWindowDataLayer(window.dataLayer)) {
    return false;
  }
  var hasMatchingEvent = function hasMatchingEvent(dataLayerEvent) {
    return Object.entries(event).every(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      return dataLayerEvent[key] === value;
    });
  };
  return window.dataLayer.some(hasMatchingEvent);
};